import type { UseQueryResult } from "@tanstack/react-query";

import { queryKeys } from "../queryKeys";
import {
  getNonIdentityAccountDocuments,
  type NonIdentityAccountDocument,
} from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetNonIdentityAccountDocuments = ({
  accountId,
  options,
}: {
  accountId?: string;
  options?: QueryOptions<NonIdentityAccountDocument[]>;
}): UseQueryResult<NonIdentityAccountDocument[]> => {
  return useRequest(
    queryKeys.documents.nonIdentity(accountId || ""),
    () => getNonIdentityAccountDocuments(accountId || ""),
    {
      enabled: !!accountId,
      ...options,
    },
  );
};
